import React from 'react';

export const DocumentsPage = () => {
    return <div>DocumentsPage</div>;
};
